<template>
  <div class="login" v-if="$parent.loaded">
    <div class="ie11-msg">
      U gebruikt Microsoft Internet Explorer,
      een verouderde browser die veiligheidslekken kan bevatten.
      Update uw browser naar
      <a href="https://www.microsoft.com/nl-nl/edge" target="_blank">
        Microsoft Edge
      </a>
      voor Windows.
    </div>
    <div class="center">
      <img v-if="style=='vm'" class="logo" src="../assets/vm/VM-logo1.svg" />
      <img v-if="style=='ox'" class="logo" src="../assets/ox/OX-logo2.svg" />
      <img v-if="style=='bvs'" class="logo" src="../assets/bvs/BVS-logo2.svg" />
      <a v-if="style=='db'" style="width:200px; display:block; margin: 0px auto 40px;" href="https://www.doelbeleggen.nl"><img src="../assets/db/DB-logo3.svg" /></a>

      <span v-if="msg" class="msg">
        <awesomeIcon icon="exclamation-circle" />
        <span v-if="reset2fa">
          Om uw autorisatie code te herstellen, kunt u
          <a @click="toPwReset" style="cursor:pointer;"><b>via deze link</b></a>
          uw wachtwoord veranderen. U kunt het ook aan ons vragen op het volgend telefoonnummer:
          020 555 0055.
        </span>
        <span v-else>{{ msg }}</span>
      </span>

      <div
        class="content-block"
        v-if="!processing && $parent.api && $parent.cookies && $parent.internet"
      >
        <form @submit.prevent="doForm">
          <input
            v-if="!two_factor && view==='login'" type="text" name="username"
            v-model="username" id="username" placeholder="Gebruikersnaam / Email" autofocus
            autocomplete="username"
          >
          <input
            v-if="view==='forgotPassword' || view==='forgotUser'"
            type="email" name="email" ref="email" placeholder="Email"
            autocomplete="email" id="email"
          >
          <div class="pass-container" v-if="!two_factor && view==='login'">
            <input
              type="password" name="password" ref="password"
              id="password" v-model="password"
              placeholder="Wachtwoord" autocomplete="password"
            >
            <div @click="fieldswitch" class="input-button">
              <awesomeIcon :icon="icon"/>
            </div>
          </div>
          <input
            v-if="view === 'reset'"
            type="password" ref="newpassword" name="password"
            placeholder="Nieuwe wachtwoord" autofocus autocomplete="new-password"
          >
          <input
            v-if="view === 'reset'"
            type="password" ref="newpassword2" name="passwordrepeat"
            placeholder="Nogmaals nieuwe wachtwoord" autocomplete="new-password"
          >
          <input
            type="text" v-if="two_factor" ref="two_factor" name="twofactor"
            id="twofactor" placeholder="Autorisatie code" autocomplete="one-time-code"
          >
          <input type="submit" :value="viewToSubmit">
        </form>
        <a v-if="!two_factor && view==='login'" @click="to('forgotUser')" class="block-button">
          <awesomeIcon icon="user" /> Gebruikersnaam opvragen
        </a>
        <a v-if="!two_factor && view==='login'" @click="to('forgotPassword')" class="block-button">
          <awesomeIcon icon="key" /> Wachtwoord herstellen
        </a>
        <a v-if="view!=='login'" @click="to('login')" class="block-button">
          <awesomeIcon icon="chevron-left" /> Terug
        </a>
      </div>

      <div v-if="style=='db' && !two_factor && view==='login'" class="register-link">
        Nog geen klant? <a @click="toRegister">Registreer hier.</a>
      </div>
      <div v-if="two_factor" class="register-link">
        Geen autorisatie code? <a @click="reset2fa = true;">Meer informatie.</a>
      </div>
      <div class="version">v. {{ $parent.formatVersion(sdkVersion) }}</div>
    </div>

    <div class="privacy">
      <a v-if="style=='ox'" href="https://oxby.nl/documentencentrum/privacy-statement/" target="_blank">Online Privacy &amp; Beleid</a>
      <a v-if="style=='bvs'" href="https://beervanstapele.nl/online-privacy/" target="_blank">Online Privacy &amp; Beleid</a>
      <a v-if="style=='vm'" href="https://velthuysemulder.nl/online-privacy/" target="_blank">Online Privacy &amp; Beleid</a>
      <template v-if="style=='db'">
        <a href="https://www.doelbeleggen.nl">Doelbeleggen.nl</a><br>
        <a href="https://www.doelbeleggen.nl/documentencentrum/privacy-statement/" target="_blank">Online Privacy &amp; Beleid</a>
      </template>
    </div>

    <div v-if="processing" class="loader"></div>

  </div>
</template>

<script>
export default {
  name: 'UserLogin',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      view: 'login',
      two_factor: false,
      msg: '',
      processing: false,
      icon: 'eye',
      username: '',
      password: '',
      reset2fa: false,
      sdkVersion: this.sdk.sdkVersion,
    };
  },
  computed: {
    viewToSubmit() {
      if (this.view === 'forgotUser') {
        return 'Gebruikersnaam opvragen';
      }
      if (this.view === 'forgotPassword') {
        return 'Wachtwoord herstellen';
      }
      if (this.view === 'reset') {
        return 'Wachtwoord instellen';
      }
      return 'Login';
    },
  },
  created() {
    if (!this.sdk.isLoggedin && this.getQueryVariable('register')) {
      if (this.getQueryVariable('register') === '5') {
        this.$store.state.currentView = 'goalWealthBuilding';
      } else if (this.getQueryVariable('register') === '4') {
        this.$store.state.currentView = 'goalLargePurchase';
      } else if (
        this.getQueryVariable('register') === '2'
        || this.getQueryVariable('register') === '3'
      ) {
        this.$store.state.currentView = 'Register2';
      } else {
        this.$store.state.currentView = 'Register';
      }
    } else if (this.sdk.isLoggedin && this.getQueryVariable('intake')) {
      this.$store.state.currentView = 'Intake';
    } else if (this.sdk.isLoggedin) {
      this.$store.state.currentView = 'Home';
    } else if (this.getQueryVariable('hash')) {
      this.view = '';
      this.sdk.checkReset(
        this.getQueryVariable('email'),
        this.getQueryVariable('hash'),
        (response) => {
          if (response.status === 200) {
            this.msg = 'Uw wachtwoord dient te bestaan uit ten minste 12 karakters. Tip: gebruik een zin die u makkelijk onthoudt of een wachtwoord generator.';
            this.view = 'reset';
          } else if (response.status === 404) {
            this.msg = 'Wachtwoord herstellink verlopen!';
            this.view = 'login';
          } else {
            this.msg = 'API onbereikbaar, probeer later opnieuw';
            this.view = '';
          }
        },
      );
    } else {
      this.view = 'login';
    }
  },
  methods: {
    doForm() {
      if (!this.processing) {
        this.processing = true;
        if (this.view === 'login') {
          this.login();
        }
        if (this.view === 'forgotUser') {
          this.requestUsername();
        }
        if (this.view === 'forgotPassword') {
          this.requestPassword();
        }
        if (this.view === 'reset') {
          this.resetPassword();
        }
      }
    },
    fieldswitch() {
      if (this.$refs.password.type === 'password') {
        this.$refs.password.type = 'text';
        this.icon = 'eye-slash';
      } else {
        this.$refs.password.type = 'password';
        this.icon = 'eye';
      }
    },
    toRegister() {
      window.location.href = '?register=1';
    },
    toPwReset() {
      this.reset2fa = false;
      this.two_factor = false;
      this.to('forgotPassword');
    },
    to(page) {
      this.msg = '';
      this.view = page;
    },
    login() {
      if (this.username) {
        if (this.password) {
          this.sdk.login(
            this.username,
            this.password,
            (response) => {
              if (response.status === 200) {
                if (response.data.message === 'Give two factor!') {
                  if (!this.two_factor) {
                    this.two_factor = true;
                    this.msg = 'Vul uw autorisatie code in';
                    this.$nextTick(() => {
                      this.$refs.two_factor.focus();
                    });
                  } else {
                    this.msg = 'Foute autorisatie code!';
                  }
                } else {
                  window.location.href = `?${
                    this.getQueryVariable('intake') ? `intake=${this.getQueryVariable('intake')}` : ''
                  }${
                    this.getQueryVariable('intake') && this.getQueryVariable('offer') ? `&offer=${this.getQueryVariable('offer')}` : ''
                  }`;
                }
              } else if (response.status === 401) {
                this.msg = 'Onbekende inloggegevens!';
              } else if (response.status === 429) {
                if (response.data.loginTimeout === 'timeout') {
                  this.msg = 'Te veel inlogpogingen in de laatste minuut, probeer het over een paar minuten nog eens.';
                } else if (response.data.loginTimeout === 'ban') {
                  this.msg = 'Te veel inlogpogingen in de laatste 12 uur, probeer het over 24 uur nog eens.';
                }
              } else {
                this.msg = 'API onbereikbaar, probeer later opnieuw';
              }
              this.processing = false;
            },
            this.$refs.two_factor ? this.$refs.two_factor.value : null,
          );
        } else {
          this.processing = false;
          this.msg = 'Geen wachtwoord opgegeven';
        }
      } else {
        this.processing = false;
        this.msg = 'Geen geldige gebruikersnaam';
      }
    },
    requestPassword() {
      if (this.$refs.email.value !== '') {
        const email = this.$refs.email.value;
        this.$refs.email.value = '';
        this.msg = 'U ontvangt reset-instructies op het e-mailadres dat reeds bij ons bekend is.';
        this.view = 'login';
        this.sdk.resetPassword(
          email,
          (response) => {
            if (response.status === 429) {
              if (response.data.resetTimeout === 'timeout') {
                this.msg = 'Te veel wachtwoordherstelpogingen in de laatste minuut, probeer het over een paar minuten nog eens.';
              } else if (response.data.resetTimeout === 'ban') {
                this.msg = 'Te veel wachtwoordherstelpogingen in de laatste 12 uur, probeer het over 24 uur nog eens.';
              }
            } else if (response.status !== 200) {
              this.msg = 'API onbereikbaar, probeer later opnieuw';
            }
            this.processing = false;
          },
        );
      } else {
        this.msg = 'Geen geldig e-mailadres';
        this.processing = false;
      }
    },
    requestUsername() {
      if (this.$refs.email.value !== '') {
        const email = this.$refs.email.value;
        this.$refs.email.value = '';
        this.msg = 'U ontvangt uw gebruikersnaam op het e-mailadres dat reeds bij ons bekend is.';
        this.view = 'login';
        this.sdk.forgotUsername(
          email,
          (response) => {
            if (response.status === 429) {
              if (response.data.usernameTimeout === 'timeout') {
                this.msg = 'Te veel gebruikersnaam opvraag pogingen in de laatste minuut, probeer het over een paar minuten nog eens.';
              } else if (response.data.usernameTimeout === 'ban') {
                this.msg = 'Te veel gebruikersnaam opvraag pogingen in de laatste 12 uur, probeer het over 24 uur nog eens.';
              }
            } else if (response.status !== 200) {
              this.msg = 'API onbereikbaar, probeer later opnieuw';
            }
            this.processing = false;
          },
        );
      } else {
        this.msg = 'Geen geldig e-mailadres';
        this.processing = false;
      }
    },
    resetPassword() {
      if (this.$refs.newpassword.value !== this.$refs.newpassword2.value) {
        this.msg = 'Nieuwe wachtwoorden komen niet overeen';
        this.processing = false;
      } else if (this.$refs.newpassword.value.length < 12) {
        this.msg = 'Uw wachtwoord is niet lang genoeg (minimaal 12 karakters)';
        this.processing = false;
      } else {
        this.sdk.doReset(
          this.getQueryVariable('email'),
          this.getQueryVariable('hash'),
          this.$refs.newpassword.value,
          (response) => {
            if (response.status === 200) {
              window.location.href = `?${
                this.getQueryVariable('intake') ? `intake=${this.getQueryVariable('intake')}` : ''
              }${
                this.getQueryVariable('intake') && this.getQueryVariable('offer') ? `&offer=${this.getQueryVariable('offer')}` : ''
              }`;
            } else if (response.status === 403) {
              this.msg = 'Er ging iets fout met het instellen van uw nieuwe wachtwoord.';
            } else {
              this.msg = 'API onbereikbaar, probeer later opnieuw';
            }
            this.processing = false;
          },
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .login {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $color-background;
    height: 100vh;
  }

  .content-block {
    width: 300px;
  }

  .center {
    top: 40%;
    max-width: 350px;
  }

  .logo {
    width: 200px;
    height: 100px;
    display: block;
    margin: 0px auto 40px;
    @media #{$mobile} {
      margin-top: 40px;
      @media (orientation:landscape) {
        display: none;
      }
    }
  }

  .msg {
    display: block;
    min-height: 36px;
    border-radius: 2px;
    border: none;
    box-sizing: border-box;
    width: 300px;
    padding: 10px 20px;
    background-color: #fcf8e3;
    color: #8a6d3b;
  }

  .register-link {
    color: #fff;
    text-align: center;
    display: block;
    margin: 40px auto 20px;
    cursor: pointer;
    a {
      color: $color-highlight;
    }
  }

  .version {
    color: #fff;
    text-align: center;
    display: block;
    margin: 0px auto 20px;
    opacity: 0.3;
    pointer-events: none;
  }

  .privacy {
    text-align: center;
    color: #fff;
    // cursor: pointer;
    position: fixed;
    bottom: 40px;
    left: 0;
    right: 0;
    @media #{$mobile} {
      display: none;
    }
  }

  .ie11-msg {
    display: none;
    @media #{$ie11} {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right:0;
      padding: 10px;
      color: #8a6d3b;
      background-color: #fff7cf;
      text-align: center;
      a {
        text-decoration: underline;
        font-weight: 600;
      }
    }
  }

  .pass-container {
    position: relative;
    .input-button {
      position: absolute;
      top: 10px;
      right: 0;
      cursor: pointer;
      padding: 10.5px;
      opacity: .5;
    }
  }
</style>
